import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class TextField extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,

    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    required: PropTypes.bool,
    multiRow: PropTypes.bool,
  };

  static defaultProps = {
    component: 'div',
    required: false,
    multiRow: false,
    className: '',
  };

  render() {
    let {
      component: Component,
      required,
      className,
      multiRow,
      readonly,
      rows,
      cols,
      id,
      value,
      ...other
    } = this.props;

    let singleLineText = (
      <>
        
          <label htmlFor={id} className="sr-only"> {/* Add a visually hidden label */}
            {value}
          </label>
        
        <input
          id={id} // Ensure the input has an id
          autoComplete="off"
          className={classNames(className)}
          required={required}
          readOnly={readonly}
          placeholder=" "
          {...other}
        />
      </>
    );

    let multiLineText = (
      <>
         <label htmlFor={id} className="sr-only"> {/* Add a visually hidden label */}
            {value}
          </label>
      <textarea
        id={id} // Ensure the textarea has an id
        className={classNames(className)}
        {...other}
        rows={rows}
        placeholder=" "
        cols={cols}
      />
      </>
    );

    return multiRow ? multiLineText : singleLineText;
  }
}

export default TextField;
